import { createSelector } from 'reselect';

import {
  CLOSE_SNACKBAR,
  ENQUEUE_SNACKBAR,
  REMOVE_SNACKBAR,
} from '../actions/notifications.actions';

const defaultState = {
  list: [],
};

export const notificationsSelector = (state: { notifications: any }) =>
  state.notifications;
export const notificationItemSelector = (key: string | number) =>
  createSelector(notificationsSelector, (notification: any) =>
    notification.list.find((item: any) => item.key === key),
  );
const notificationsReducer: any = (state: any = defaultState, action: any) => {
  const { payload } = action;
  switch (action.type) {
    case ENQUEUE_SNACKBAR:
      return {
        ...state,
        list: [
          ...state.list,
          {
            key: payload.key,
            variant: payload.notification.options.variant,
            ...payload.notification,
          },
        ],
      };

    case CLOSE_SNACKBAR:
      return {
        ...state,
        list: state.list.map((notification: any) =>
          payload.dismissAll || notification.key === payload.key
            ? { ...notification, dismissed: true }
            : { ...notification },
        ),
      };

    case REMOVE_SNACKBAR:
      return {
        ...state,
        list: state.list.filter(
          (notification: any) => notification.key !== payload.key,
        ),
      };

    default:
      return state;
  }
};

export default notificationsReducer;
